import './pdf-preview.scss';

export default function PDFPreview ({
    url,
    customClassName,
} : {
    url: string;
    customClassName?: string;
}) {

    return (
        <iframe
            src={url}
            className={`pdf-preview ${customClassName ?? ''}`}
        ></iframe>
    )
}